import { Navigate } from "react-router-dom";

const PublicRouter = ({ children }) => {
    const isLogin = localStorage.getItem("isLoggedIn") === "true";

    return isLogin
        ? <Navigate to="/dashboard" replace />
        : children;
};

export default PublicRouter;